export default {
	nav: {
		features: "Recursos",
		screens: "Telas",
		plans: "Planos",
		faq: "Dúvidas",
		contact: "Contato",
		login: "Entrar",
		tryFree: "Testar grátis",
		lightMode: "Modo claro",
		darkMode: "Modo escuro",
	},
	hero: {
		eyebrow: "Gestão para terreiros de Umbanda",
		titleLine1: "Cuide do axé.",
		titleLine2: "O ORI cuida da gestão.",
		lead: "Consulentes, corrente, rituais, fichas, financeiro e comunicação — tudo num só lugar, com respeito às tradições e a simplicidade que a sua casa merece.",
		ctaPrimary: "Começar teste grátis",
		ctaSecondary: "Ver o sistema por dentro",
		trust: "30 dias grátis · não pedimos cartão para começar",
		memberQuestion: "Recebeu um convite do seu terreiro?",
		memberLink: "Entrar como membro",
		shotAlt: "Painel do ORI",
	},
	features: {
		eyebrow: "Recursos",
		title: "Tudo o que a sua casa precisa",
		subtitle: "Um sistema pensado para o dia a dia do terreiro — do cadastro do consulente à chamada de fichas na televisão do salão.",
		more: "E ainda: painel e relatórios · fotos nos perfis · retornos e acompanhamento · disponível em 4 idiomas.",
		note: "Pagamentos e alertas por WhatsApp são adicionais opcionais. As taxas de cada transação no Mercado Pago são cobradas pela própria plataforma, não pelo ORI.",
		people: {
			title: "Pessoas e corrente",
			text: "Consulentes, médiuns e membros com cadastro completo, fotos e histórico de frequência.",
		},
		journey: {
			title: "Jornada do médium",
			text: "Acompanhe a evolução mediúnica: guias, orixás e marcos de desenvolvimento.",
		},
		rituals: {
			title: "Rituais e giras",
			text: "Agenda de rituais, tipos de ritual e controle de presença da corrente.",
		},
		agenda: {
			title: "Agenda pública e reservas",
			text: "Publique seus rituais num link único e receba reservas de presença dos consulentes — com aprovação e controle de vagas.",
		},
		tickets: {
			title: "Fichas e atendimento",
			text: "Distribua fichas por guia e médium e imprima em impressora térmica por menos de 1 centavo.",
		},
		tv: {
			title: "ORI TV — chamada na TV",
			text: "A chamada de fichas na televisão do salão, em tempo real e com aviso sonoro.",
		},
		financial: {
			title: "Financeiro",
			text: "Fundos, contribuições, mensalidades e relatórios: as contas da casa sob controle.",
		},
		payments: {
			title: "Pagamentos por PIX",
			text: "Cobre mensalidades e contribuições por PIX ou cartão, com baixa automática e débito recorrente.",
		},
		whatsapp: {
			title: "Avisos no WhatsApp",
			text: "Cobranças, confirmações e lembretes também no WhatsApp, com consentimento de cada pessoa.",
		},
		assistant: {
			title: "Assistente com IA",
			text: "Um assistente dentro do sistema que tira dúvidas e ajuda a configurar a casa passo a passo.",
		},
	},
	screens: {
		eyebrow: "Por dentro",
		title: "As telas que você vai usar todo dia",
		subtitle: "Sem enrolação: é assim que o ORI se parece de verdade.",
		prev: "Anterior",
		next: "Próxima",
		dashboard: {
			title: "Painel geral",
			desc: "A casa num relance: métricas, aniversariantes, próximos rituais e gráficos.",
		},
		consulentes: {
			title: "Consulentes",
			desc: "Busca, filtros e histórico de atendimentos de cada consulente.",
		},
		corrente: {
			title: "Corrente mediúnica",
			desc: "Médiuns com jornada espiritual, orixás e funções na casa.",
		},
		rituais: {
			title: "Rituais",
			desc: "Detalhes do ritual: status, tipo, fichas e estatísticas.",
		},
		agenda: {
			title: "Agenda pública",
			desc: "Um link para o consulente ver os próximos rituais e reservar presença, sem login.",
		},
		financeiro: {
			title: "Financeiro",
			desc: "Fundos, metas, fluxo de caixa e gráficos num só painel.",
		},
		pagamentos: {
			title: "Pagamentos por PIX",
			desc: "Cobrança pelo Mercado Pago com baixa automática e débito recorrente.",
		},
		assistente: {
			title: "Assistente ORI",
			desc: "A IA que tira dúvidas e ajuda a configurar a casa passo a passo.",
		},
		atendimento: {
			title: "Distribuição de fichas",
			desc: "Fichas organizadas por guia e médium responsável.",
		},
		oritv: {
			title: "ORI TV",
			desc: "Chamada de fichas na televisão do salão — o consulente acompanha sua vez.",
		},
		ticket: {
			title: "Ficha impressa",
			desc: "Código, guia, médium e horário impressos por menos de 1 centavo.",
		},
	},
	testimonials: {
		eyebrow: "Quem usa",
		title: "Casas que respiram mais leve",
		more: "ler mais…",
		less: "mostrar menos",
		prev: "Anterior",
		next: "Próximo",
		jean: {
			p1: "Antes de utilizar o ORI, grande parte do nosso tempo era consumida por processos administrativos manuais, como o gerenciamento de rituais, atendimentos, controle financeiro e diversas outras tarefas do dia a dia do terreiro.",
			p2: "Com o ORI, toda essa gestão se tornou muito mais simples, organizada e eficiente. Hoje conseguimos administrar tudo com muito mais agilidade, segurança e praticidade.",
			p3: "O maior benefício é que deixamos de gastar tempo com burocracias e podemos dedicar nossa energia ao que realmente importa: a caridade, o acolhimento e o atendimento espiritual às pessoas.",
			p4: "Parabenizo toda a equipe pelo excelente trabalho. Recomendo o ORI a todos os terreiros que desejam modernizar sua gestão sem perder o fundamento e a essência da religião.",
		},
		priscilla: {
			p1: "O ORI veio como uma excelente ferramenta para nosso terreiro em questão de controle de frequentadores e histórico dos mesmos.",
			p2: "Nossa casa tem como regra distribuir atendimentos direcionando a entidades específicas, e o ORI me auxilia com o histórico, e até mesmo na questão do pedido das entidades para o consulente retornar.",
			p3: "Além disso tem o cadastro de todos os médiuns da casa, alertas para aniversariantes, alertas financeiros para pagamentos das mensalidades, e controle de caixa, onde conseguimos em apenas uma ferramenta ter visão de toda nossa organização.",
			p4: "Para mim o ORI veio facilitar e organizar nossos dados. Como organização religiosa não temos alguém dedicado apenas para isso, então nossos admins alimentam o sistema e facilita para quando eu preciso colher dados precisos em um só lugar.",
			p5: "Super recomendo para Mães e Pais de Santo que, como eu, têm uma vida profissional agitada, mas não abrem mão de deixar nossa casa espiritual sempre em ordem.",
		},
	},
	plans: {
		eyebrow: "Planos",
		title: "Um plano que cabe na sua casa",
		subtitle: "Uma base ORI mais os adicionais que você quiser. Os 30 dias grátis valem para o plano base — sem compromisso e sem cartão.",
		fallback: "Não conseguimos carregar os planos agora.",
		fallbackCta: "Testar 30 dias grátis",
	},
	faq: {
		eyebrow: "Dúvidas",
		title: "Perguntas frequentes",
		trial: {
			q: "Eu posso testar o ORI?",
			a: "Sim. São 30 dias grátis no plano base, sem cartão de crédito. Os adicionais — pagamentos pelo Mercado Pago e alertas por WhatsApp — não entram no teste.",
		},
		security: {
			q: "Meus dados ficam seguros?",
			a: "Absolutamente. Usamos criptografia, isolamento por templo e backups automáticos. Nenhum terreiro acessa os dados de outro.",
		},
		mobile: {
			q: "Funciona no celular e no tablet?",
			a: "Em tablets, o sistema funciona perfeitamente. A versão para celular está em evolução.",
		},
		tv: {
			q: "Consigo chamar fichas na TV?",
			a: "Sim. O ORI tem um aplicativo para Google TV ou Fire TV que chama as fichas em tempo real, além de exibir mensagens e vídeos personalizados aos consulentes.",
		},
		tickets: {
			q: "Posso usar minhas fichas físicas?",
			a: "Pode usar as suas fichas físicas ou imprimir em impressora térmica por menos de 1 centavo por ficha — com código, guia, médium e horário, e até mensagens personalizadas.",
		},
		multiTemple: {
			q: "Posso usar em mais de um terreiro?",
			a: "Sim. Uma mesma conta pode estar vinculada a vários templos com papéis diferentes, e cada templo tem seu próprio plano e assinatura.",
		},
		payments: {
			q: "O ORI recebe pagamentos?",
			a: "Sim, pelo Mercado Pago. A integração é um adicional opcional do plano: você conecta a conta do templo e cobra mensalidades e contribuições por PIX ou cartão, com baixa automática e débito recorrente. As taxas de cada transação são cobradas pelo próprio Mercado Pago, e o dinheiro cai direto na conta do templo.",
		},
	},
	cta: {
		eyebrow: "Comece hoje",
		title: "Pronto para organizar a sua casa?",
		text: "Experimente o ORI por 30 dias, sem compromisso e sem cartão. Leva poucos minutos para começar.",
		primary: "Criar meu terreiro",
		secondary: "Falar com a gente",
	},
	footer: {
		tagline: "Construído de um filho do Axé para outro filho do Axé.",
		invite: "Tenho um convite",
		manual: "Manual",
		terms: "Termos de Uso",
		privacy: "Política de Privacidade",
		cause: "Apoiamos a causa autista",
		causeAlt: "Laço do Autismo",
	},
};
